import * as actions from '../actions/brokers';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenSequentially from "xstream/extra/flattenSequentially";

export function requestBrokersSuggestions(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_BROKERS_SUGGESTIONS)
        .map(action => ({
            url: BASE_URL + 'api/users/brokers?' +
                `limit=${action.payload.limit}` +
                `&offset=${action.payload.offset}` +
                (action.payload.search?`&search=${action.payload.search}`:''),
            category: 'requestBrokersSuggestions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestBrokersSuggestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenSequentially)
        .filter(response => response.status === 200)
        .map(response => actions.getBrokersSuggestionsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestBrokersSuggestionsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestBrokersSuggestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenSequentially)
        .filter(response => response.status !==200)
        .map(response => actions.getBrokersSuggestionsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestBrokers(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_BROKERS)
        .map(action => ({
            url: BASE_URL + 'api/users/brokers?' +
                `limit=${action.payload.limit}` +
                `&offset=${action.payload.offset}` +
                `&orderAsc=${action.payload.orderAsc}`+
                `&orderBySolicitorName=${action.payload.orderBySolicitorName}`+
                `&orderByUserName=${action.payload.orderByUserName}` +
                `&orderByLawsysId=${action.payload.orderByLawsysId}` +
                `&orderByLawsysName=${action.payload.orderByLawsysName}` +
                (action.payload.search?`&search=${action.payload.search}`:'') +
                (action.payload.lawsysId?`&lawsysId=${action.payload.lawsysId}`:''),
            category: 'requestBrokers',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestBrokers')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getBrokersSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestBrokersFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestBrokers')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getBrokersFailed(response));

    return {
        ACTION: httpResponse$
    };
}